export const KS_ENV = process.env.REACT_APP_KS_ENV;
export const IS_E2E = KS_ENV === 'e2e';
